import React from 'react';
import { useHistory } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import { Home, Download } from '@mui/icons-material';
import { useSite } from '../context/SiteContext';

export default function NotFound() {
  const history = useHistory();
  const { settings } = useSite();

  const openDownloadPopup = () => {
    window.dispatchEvent(new CustomEvent('waya-open-download-popup'));
  };

  return (
    <div className="waya-notfound-page-premium">
      {/* Spacer to fix navbar overlap */}
      <div style={{ height: '100px' }}></div>
      
      <div className="notfound-hero-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <Fade bottom>
                <div className="notfound-badge mb-4">404 Error</div>
                <h1 className="notfound-main-title">Lost in the Cloud?</h1>
                <p className="notfound-description mb-5">
                  The page you're looking for seems to have drifted away. 
                  Don't worry, your money is safe! Let's get you back to {settings?.site_name || 'WayaBank'}.
                </p>
                
                <div className="notfound-cta-group d-flex justify-content-center gap-3 flex-wrap">
                  <button 
                    onClick={() => history.push('/')}
                    className="waya-btn-primary d-flex align-items-center gap-2"
                  >
                    <Home fontSize="small" /> Back to Home
                  </button>
                  <button 
                    onClick={openDownloadPopup}
                    className="waya-btn-outline d-flex align-items-center gap-2"
                    style={{ background: 'white' }}
                  >
                    <Download fontSize="small" /> Download App
                  </button>
                </div>
              </Fade>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="notfound-glow-1"></div>
        <div className="notfound-glow-2"></div>
      </div>


    </div>
  );
}
